import StlapFooter from "../CustomComponents/StlapFooter";
import LoanClosureDetail from "./LoanClosureDetail";
import LoanClosureFilter from "./LoanClosureFilter";

const LoanClosure = () => {
  return (
    <>
      <LoanClosureFilter />
    </>
  );
};
export default LoanClosure;
